import { application } from "./application";
import { AgendaItemFormController } from "./agenda_item_form_controller";
import { ConfirmationMessageFormController } from "./confirmation_message_form_controller";
import { AvatarFieldController } from "./form_helpers/avatar_field_controller";
import { AppNavSortableController } from "./app_nav_sortable_controller";
import { ChatPanelController } from "./chat_panel_controller";
import { ChatSidebarController } from "./chat_sidebar_controller";
import { ClipboardController } from "./clipboard_controller";
import { SharepointImportFormController } from "./sharepoint_import_form_controller";
import { PollReloadController } from "./poll_reload_controller";
import { ComboboxController } from "./combobox_controller";
import { EventLogComposerController } from "./event_log_composer_controller";
import { EventLogDeeplinkController } from "./event_log_deeplink_controller";
import { EventLogRespondController } from "./event_log_respond_controller";
import { CheckoutFormController } from "./payment/checkout_form_controller";
import { CurrencyMaskController } from "./form_helpers/currency_mask_controller";
import { DownloadTrayController } from "./download_tray_controller";
import { OperationsTrayController } from "./operations_tray_controller";
import { ToastManagerController } from "./toast_manager_controller";
import { DatePickerFormController } from "./form_helpers/date_picker_form_controller";
import { DirtyFormController } from "./form_helpers/dirty_form_controller";
import { FormEditorController } from "./editors/form_editor_controller";
import { GroupedCheckboxController } from "./form_helpers/grouped_checkbox_controller";
import { HelpBeaconController } from "./help_beacon_controller";
import { LeadScanGridController } from "./grids/lead_scan_grid_controller";
import { LeadScanPrimerGridController } from "./grids/lead_scan_primer_grid_controller";
import { MetadataModalController } from "./form_helpers/metadata_modal_controller";
import { MicrositeEditorController } from "./editors/microsite_editor_controller";
import { MutexCheckboxesController } from "./form_helpers/mutex_checkboxes_controller";
import { NestedRevealController } from "./form_helpers/nested_reveal_controller";
import { NoEmailController } from "./form_helpers/no_email_controller";
import { NameBadgeGridController } from "./grids/name_badge_grid_controller";
import { NameBadgePrimerGridController } from "./grids/name_badge_primer_grid_controller";
import { EventAssignmentsGridController } from "./grids/event_assignments_grid_controller";
import { ReadOnlyGridController } from "./grids/read_only_grid_controller";
import { PermissionsGridController } from "./grids/permissions_grid_controller";
import { ReadOnlyPrimerGridController } from "./grids/read_only_primer_grid_controller";
import { EventsGridController } from "./grids/events_grid_controller";
import { EventRequestsGridController } from "./grids/event_requests_grid_controller";
import { ReorderablePrimerGridController } from "./grids/reorderable_primer_grid_controller";
import { BlockedDatesGridController } from "./grids/blocked_dates_grid_controller";
import { RefreshController } from "./refresh_controller";
import { SimpleGridController } from "@/controllers/grids/simple_grid_controller";
import { ReadOnlyPrimerCheckinGridController } from "./grids/read_only_primer_checkin_grid_controller";
import { ReportPrimerGridController } from "./grids/report_primer_grid_controller";
import { ResourceAccessController } from "./admin/resource_access_controller";

import { RegFormController } from "./form_helpers/reg_form_controller";
import { ReportGridController } from "./grids/report_grid_controller";
import { RefundTypeToggleController } from "./form_helpers/refund_type_toggle_controller";
import { RefundNeedsCreditController } from "./form_helpers/refund_needs_credit_controller";

import { TrackFilterToggleController } from "@/controllers/form_helpers/track_filter_toggle_controller";
import { DeepLinkTargetToggleController } from "@/controllers/form_helpers/deep_link_target_toggle_controller";
import { EventDayFilterToggleController } from "@/controllers/form_helpers/event_day_filter_toggle_controller";
import { DayAssignmentToggleController } from "@/controllers/form_helpers/day_assignment_toggle_controller";
import { RecipientsFilterToggleController } from "@/controllers/form_helpers/recipients_filter_toggle_controller";
import { VisibilityToggleController } from "./form_helpers/visibility_toggle_controller";
import { TimeTypeToggleController } from "./form_helpers/time_type_toggle_controller";
import { RoomingFieldController } from "./rooming/rooming_field_controller";
import { TipTapHandlebarsController } from "./tip_tap_handlebars_controller";
import { TranslationFormController } from "./greg_translate/translation-form-controller";
import CollapsibleNavigationController from "./collapsible_navigation_controller";
import { CollaborativeMicrositeEditorController } from "@/controllers/editors/collaborative_microsite_editor_controller";
import { CollaborativeFormEditorController } from "./editors/collaborative_form_editor_controller";
import { AdminEventsCalendarController } from "./calendar/admin_events_calendar_controller";
import { AdminFacilitiesMatrixController } from "./calendar/admin_facilities_matrix_controller";
import { AdminFacilityDayScheduleController } from "./calendar/admin_facility_day_schedule_controller";
import { AdminVenueCalendarController } from "./calendar/admin_venue_calendar_controller";
import { EventRequestFieldGridController } from "./grids/event_request_field_grid_controller";
import { SelectPanelController } from "./form_helpers/select_panel_controller";
import { SquareCheckoutFormController } from "./payment/square_checkout_form_controller";
import { AsyncExportController } from "./async_export_controller";
import { AzureAdLookupController } from "./form_helpers/azure_ad_lookup_controller";
import { RoleSelectorController } from "./form_helpers/role_selector_controller";
import { GroupedPermissionController } from "./form_helpers/grouped_permission_controller";
import { PermissionEditorController } from "./form_helpers/permission_editor_controller";
import EventRequestDatesController from "./event_request_dates_controller";
import EventRequestConvertController from "./event_request_convert_controller";
import ConvertRegistrationCloseController from "./convert_registration_close_controller";
import VenueLayoutTiersController from "./venue_layout_tiers_controller";
import TemplateStartController from "./template_start_controller";
import TemplateCloseController from "./template_close_controller";
import EventCreateModeController from "./event_create_mode_controller";
import EventRequestWizardController from "./event_request_wizard_controller";
import EventRequestScheduleController from "./event_request_schedule_controller";
import EventRequestFacilityController from "./event_request_facility_controller";
import EventRequestAdditionalSpaceController from "./event_request_additional_space_controller";
import EventRequestRoomBlockController from "./event_request_room_block_controller";
import EventRequestSpaceNeedsController from "./event_request_space_needs_controller";
import EventRequestAvNeedsController from "./event_request_av_needs_controller";
import SelectPanelGroupsController from "./select_panel_groups_controller";
import SelectPanelFitController from "./select_panel_fit_controller";
import SourcingPropertyPickerController from "./sourcing_property_picker_controller";
import SourcingMapController from "./sourcing_map_controller";
import QuoteLineItemsController from "./quote_line_items_controller";
import QuoteLineSortableController from "./quote_line_sortable_controller";
import AvQuoteLinesController from "./av_quote_lines_controller";
import QuoteConcessionsController from "./quote_concessions_controller";
import HotelRoomBlockController from "./hotel_room_block_controller";
import InviteesController from "./invitees_controller";
import BulkInviteesController from "./bulk_invitees_controller";
import ReviewerActionController from "./reviewer_action_controller";
import TermsAcceptanceController from "./terms_acceptance_controller";
import { TieredListSortableController } from "./tiered_list_sortable_controller";
import { TieredListFileFieldsController } from "./tiered_list_file_fields_controller";
import { FieldSchemaBuilderController } from "./field_schema_builder_controller";
import { TieredListNameDefaultController } from "./tiered_list_name_default_controller";
import { MicrositeUpgradeController } from "./microsite_upgrade_controller";
import { CloneOptionsController } from "./clone_options_controller";
import { RecoveryCodesController } from "./recovery_codes_controller";
import FlashToastController from "./flash_toast_controller";

application.register("agenda-item-form", AgendaItemFormController);
application.register("confirmation-message-form", ConfirmationMessageFormController);
application.register("app-nav-sortable", AppNavSortableController);
application.register("async-export", AsyncExportController);
application.register("azure-ad-lookup", AzureAdLookupController);
application.register("chat-panel", ChatPanelController);
application.register("chat-sidebar", ChatSidebarController);
application.register("clipboard", ClipboardController);
application.register("combobox", ComboboxController);
application.register("event-log-composer", EventLogComposerController);
application.register("event-log-deeplink", EventLogDeeplinkController);
application.register("event-log-respond", EventLogRespondController);
application.register("recovery-codes", RecoveryCodesController);
application.register("checkout-form", CheckoutFormController);
application.register("collapsible-navigation", CollapsibleNavigationController);
application.register("download-tray", DownloadTrayController);
application.register("operations-tray", OperationsTrayController);
application.register("toast-manager", ToastManagerController);
application.register("currency-mask", CurrencyMaskController);
application.register("avatar-field", AvatarFieldController);
application.register("date-picker-form", DatePickerFormController);
application.register("dirty-form", DirtyFormController);
application.register("form-editor", FormEditorController);
application.register(
  "collaborative-form-editor",
  CollaborativeFormEditorController
);
application.register("grouped-checkbox", GroupedCheckboxController);
application.register("help-beacon", HelpBeaconController);
application.register("lead-scan-grid", LeadScanGridController);
application.register("lead-scan-primer-grid", LeadScanPrimerGridController);
application.register("metadata-modal", MetadataModalController);
application.register("mutex-checkboxes", MutexCheckboxesController);
application.register("nested-reveal", NestedRevealController);
application.register(
  "collaborative-microsite-editor",
  CollaborativeMicrositeEditorController
);
application.register("microsite-editor", MicrositeEditorController);
application.register("name-badge-grid", NameBadgeGridController);
application.register("no-email", NoEmailController);
application.register("name-badge-primer-grid", NameBadgePrimerGridController);
application.register("event-assignments-grid", EventAssignmentsGridController);
application.register("permissions-grid", PermissionsGridController);
application.register("read-only-grid", ReadOnlyGridController);
application.register("read-only-primer-grid", ReadOnlyPrimerGridController);
application.register("events-grid", EventsGridController);
application.register("event-requests-grid", EventRequestsGridController);
application.register("reorderable-primer-grid", ReorderablePrimerGridController);
application.register("blocked-dates-grid", BlockedDatesGridController);
application.register("read-only-primer-checkin-grid", ReadOnlyPrimerCheckinGridController);
application.register("refresh", RefreshController);
application.register("sharepoint-import-form", SharepointImportFormController);
application.register("poll-reload", PollReloadController);
application.register("reg-form", RegFormController);
application.register("report-grid", ReportGridController);
application.register("report-primer-grid", ReportPrimerGridController);
application.register("refund-type-toggle", RefundTypeToggleController);
application.register("refund-needs-credit", RefundNeedsCreditController);

application.register("track-filter-toggle", TrackFilterToggleController);
application.register("deep-link-target-toggle", DeepLinkTargetToggleController);
application.register("event-day-filter-toggle", EventDayFilterToggleController);
application.register("day-assignment-toggle", DayAssignmentToggleController);
application.register(
  "recipients-filter-toggle",
  RecipientsFilterToggleController
);
application.register("time-type-toggle", TimeTypeToggleController);
application.register("visibility-toggle", VisibilityToggleController);
application.register("agenda-toggle", VisibilityToggleController);
application.register("rooming-field", RoomingFieldController);
application.register("simple-grid", SimpleGridController);
application.register("square-checkout-form", SquareCheckoutFormController);
application.register("tip-tap-handlebars", TipTapHandlebarsController);
application.register("translation-form", TranslationFormController);
application.register("select-panel", SelectPanelController);
application.register("role-selector", RoleSelectorController);
application.register("grouped-permission", GroupedPermissionController);
application.register("permission-editor", PermissionEditorController);
application.register("admin-events-calendar", AdminEventsCalendarController);
application.register("admin-facilities-matrix", AdminFacilitiesMatrixController);
application.register("admin-facility-day-schedule", AdminFacilityDayScheduleController);
application.register("admin-venue-calendar", AdminVenueCalendarController);
application.register("event-request-field-grid", EventRequestFieldGridController);
application.register("event-request-dates", EventRequestDatesController);
// GR-3516: registered at last. The controller shipped with GR-1787 but was
// never imported, so the Create Event button it gates stayed disabled forever
// once a blocked date or an over-capacity day put an acknowledgement on the
// page. Server-side guards were doing the real work; this restores the UX half.
application.register("event-request-convert", EventRequestConvertController);
application.register("convert-registration-close", ConvertRegistrationCloseController);
application.register("venue-layout-tiers", VenueLayoutTiersController);
application.register("template-start", TemplateStartController);
application.register("template-close", TemplateCloseController);
application.register("event-create-mode", EventCreateModeController);
application.register("event-request-wizard", EventRequestWizardController);
application.register("event-request-schedule", EventRequestScheduleController);
application.register("event-request-space-needs", EventRequestSpaceNeedsController);
application.register("event-request-av-needs", EventRequestAvNeedsController);
application.register("event-request-facility", EventRequestFacilityController);
application.register(
  "event-request-additional-space",
  EventRequestAdditionalSpaceController
);
application.register("event-request-room-block", EventRequestRoomBlockController);
application.register("select-panel-groups", SelectPanelGroupsController);
application.register("select-panel-fit", SelectPanelFitController);
application.register("sourcing-property-picker", SourcingPropertyPickerController);
application.register("sourcing-map", SourcingMapController);
application.register("quote-line-items", QuoteLineItemsController);
application.register("quote-line-sortable", QuoteLineSortableController);
application.register("av-quote-lines", AvQuoteLinesController);
application.register("quote-concessions", QuoteConcessionsController);
application.register("hotel-room-block", HotelRoomBlockController);
application.register("invitees", InviteesController);
application.register("bulk-invitees", BulkInviteesController);
application.register("reviewer-action", ReviewerActionController);
application.register("terms-acceptance", TermsAcceptanceController);
application.register("resource-access", ResourceAccessController);
application.register("tiered-list-sortable", TieredListSortableController);
application.register("tiered-list-file-fields", TieredListFileFieldsController);
application.register("field-schema-builder", FieldSchemaBuilderController);
application.register("tiered-list-name-default", TieredListNameDefaultController);
application.register("microsite-upgrade", MicrositeUpgradeController);
application.register("clone-options", CloneOptionsController);
application.register("flash-toast", FlashToastController);
